// Gamepad input (standard mapping: Xbox/PlayStation layouts in modern browsers).
// Dead zone, response curve and look speed follow Kinema's InputManager
// (https://github.com/2600th/Kinema, MIT, © 2026 Pranshul Chandhok).
const DEADZONE = 0.12;
const CURVE = 1.4;
export const GAMEPAD_LOOK_SPEED = 2.6; // radians per second at full stick

function shape(v: number) {
  const a = Math.abs(v);
  if (a < DEADZONE) return 0;
  const t = (a - DEADZONE) / (1 - DEADZONE);
  return Math.sign(v) * Math.pow(t, CURVE);
}

export interface PadState {
  connected: boolean;
  moveX: number; // right +
  moveY: number; // forward +
  lookX: number;
  lookY: number;
  jump: boolean; // A / Cross
  interact: boolean; // X / Square (also B / Circle)
  dance: boolean; // Y / Triangle
  sprint: boolean; // left stick press or left bumper/trigger
  throttle: number; // right trigger (driving)
  brake: number; // left trigger (driving)
}
const EMPTY: PadState = { connected: false, moveX: 0, moveY: 0, lookX: 0, lookY: 0, jump: false, interact: false, dance: false, sprint: false, throttle: 0, brake: 0 };

export function readGamepad(): PadState {
  const pads = typeof navigator !== "undefined" && navigator.getGamepads ? navigator.getGamepads() : [];
  const pad = Array.from(pads ?? []).find((p) => p && p.connected);
  if (!pad) return EMPTY;
  const b = (i: number) => !!pad.buttons[i]?.pressed;
  const v = (i: number) => pad.buttons[i]?.value ?? 0;
  return {
    connected: true,
    moveX: shape(pad.axes[0] ?? 0),
    moveY: -shape(pad.axes[1] ?? 0),
    lookX: shape(pad.axes[2] ?? 0),
    lookY: shape(pad.axes[3] ?? 0),
    jump: b(0),
    interact: b(2) || b(1),
    dance: b(3),
    sprint: b(10) || b(4),
    throttle: v(7),
    brake: v(6),
  };
}
